<!-- 模板 -->
<template>
    <div class="departments">
      <!-- <h2>科室管理</h2> -->
      
      <!-- 操作按钮区 -->
      <div class="operation-area">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加科室</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="importDialogVisible = true">批量导入</el-button>
        <el-input
          v-model="searchKeyword"
          placeholder="请输入科室名称或编号"
          style="width: 250px; margin-left: 10px"
          prefix-icon="el-icon-search"
          @input="handleSearch"
          clearable
        ></el-input>
      </div>
      
      <!-- 科室表格 -->
      <el-table
        :data="filteredDepartments"
        border
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
      >
        <el-table-column prop="deptId" label="科室编号" width="100"></el-table-column>
        <el-table-column prop="deptName" label="科室名称" width="150"></el-table-column>
        <el-table-column prop="description" label="科室简介" show-overflow-tooltip></el-table-column>
        <el-table-column prop="director" label="科室主任" width="120"></el-table-column>
        <el-table-column prop="phone" label="联系电话" width="130"></el-table-column>
        <el-table-column prop="doctorCount" label="医生数量" width="100" sortable></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="150"></el-table-column>
        <el-table-column label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button 
              size="mini" 
              type="danger" 
              icon="el-icon-delete" 
              :disabled="scope.row.doctorCount > 0"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      
      <!-- 添加/编辑科室对话框 -->
      <el-dialog 
        :title="dialogTitle" 
        :visible.sync="dialogVisible" 
        width="600px"
        :close-on-click-modal="false"
      >
        <el-form :model="deptForm" :rules="deptRules" ref="deptForm" label-width="100px">
          <el-form-item label="科室编号" prop="deptId">
            <el-input v-model="deptForm.deptId" placeholder="请输入科室编号" :disabled="dialogType === 'edit'"></el-input>
          </el-form-item>
          <el-form-item label="科室名称" prop="deptName">
            <el-input v-model="deptForm.deptName" placeholder="请输入科室名称"></el-input>
          </el-form-item>
          <el-form-item label="科室主任" prop="director">
            <el-input v-model="deptForm.director" placeholder="请输入科室主任姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="deptForm.phone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="科室简介" prop="description">
            <el-input type="textarea" v-model="deptForm.description" :rows="4" placeholder="请输入科室简介"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 导入科室对话框 -->
      <el-dialog
        title="批量导入科室"
        :visible.sync="importDialogVisible"
        width="500px"
      >
        <div class="import-tip">
          <i class="el-icon-info" style="color: #E6A23C; margin-right: 5px;"></i>
          请按照模板格式导入科室信息，模板可
          <el-link type="primary" @click="downloadTemplate">点击下载</el-link>
        </div>
        <el-upload
          class="upload-demo"
          drag
          action="/api/department/import"
          :auto-upload="false"
          :on-change="handleFileChange"
          :file-list="fileList"
          accept=".xlsx,.xls"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件，且不超过10MB</div>
        </el-upload>
        <div slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitImport">确定导入</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'departments',
    data() {
      return {
        // 表格数据
        departments: [
          {
            deptId: 'DEPT001',
            deptName: '内科',
            description: '主要负责诊治内脏疾病，包括心血管、呼吸、消化、内分泌等系统疾病的诊治工作。',
            director: '张医生',
            phone: '010-12345678',
            doctorCount: 12,
            createTime: '2023-10-12 08:30:00'
          },
          {
            deptId: 'DEPT002',
            deptName: '外科',
            description: '主要处理各种外伤以及需要手术干预的疾病，包括普外科、骨科、神经外科等。',
            director: '李医生',
            phone: '010-12345679',
            doctorCount: 15,
            createTime: '2023-10-12 09:15:00'
          },
          {
            deptId: 'DEPT003',
            deptName: '妇产科',
            description: '专注于女性生殖系统疾病和孕产相关服务，提供孕前、孕期和产后的医疗保健。',
            director: '王医生',
            phone: '010-12345680',
            doctorCount: 8,
            createTime: '2023-10-13 10:20:00'
          },
          {
            deptId: 'DEPT004',
            deptName: '儿科',
            description: '专业从事儿童及青少年疾病的诊断与治疗，提供全面的小儿医疗服务。',
            director: '刘医生',
            phone: '010-12345681',
            doctorCount: 10,
            createTime: '2023-10-14 11:00:00'
          },
          {
            deptId: 'DEPT005',
            deptName: '神经科',
            description: '主要负责各类神经系统疾病诊治，如癫痫、脑血管疾病、神经退行性疾病等。',
            director: '赵医生',
            phone: '010-12345682',
            doctorCount: 0,
            createTime: '2023-10-15 13:45:00'
          },
          {
            deptId: 'DEPT006',
            deptName: '眼科',
            description: '专注于眼部疾病的诊断和治疗，包括近视、白内障、青光眼等眼部疾病。',
            director: '孙医生',
            phone: '010-12345683',
            doctorCount: 6,
            createTime: '2023-10-16 14:30:00'
          },
          {
            deptId: 'DEPT007',
            deptName: '耳鼻喉科',
            description: '主要处理耳、鼻、咽喉相关疾病，如中耳炎、鼻窦炎、扁桃体炎等。',
            director: '周医生',
            phone: '010-12345684',
            doctorCount: 5,
            createTime: '2023-10-17 15:20:00'
          }
        ],
        // 表格加载状态
        loading: false,
        // 搜索关键词
        searchKeyword: '',
        // 分页相关
        currentPage: 1,
        pageSize: 10,
        totalCount: 7,
        
        // 弹窗相关
        dialogVisible: false,
        dialogTitle: '添加科室',
        dialogType: 'add', // 'add' 或 'edit'
        deptForm: {
          deptId: '',
          deptName: '',
          description: '',
          director: '',
          phone: ''
        },
        deptRules: {
          deptId: [
            { required: true, message: '请输入科室编号', trigger: 'blur' },
            { min: 3, max: 10, message: '长度在 3 到 10 个字符', trigger: 'blur' }
          ],
          deptName: [
            { required: true, message: '请输入科室名称', trigger: 'blur' }
          ],
          director: [
            { required: true, message: '请输入科室主任姓名', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
            { pattern: /^[\d-]{8,13}$/, message: '请输入正确的电话格式', trigger: 'blur' }
          ]
        },
        
        // 导入相关
        importDialogVisible: false,
        fileList: []
      }
    },
    computed: {
      // 过滤后的科室列表（用于搜索功能）
      filteredDepartments() {
        if (!this.searchKeyword) {
          return this.departments
        }
        const keyword = this.searchKeyword.toLowerCase()
        return this.departments.filter(dept => 
          dept.deptName.toLowerCase().includes(keyword) || 
          dept.deptId.toLowerCase().includes(keyword)
        )
      }
    },
    methods: {
      // 搜索处理
      handleSearch() {
        this.currentPage = 1;
        // 实际应用中这里可能需要调用API进行后端搜索
      },
      
      // 添加科室
      handleAdd() {
        this.dialogType = 'add';
        this.dialogTitle = '添加科室';
        this.deptForm = {
          deptId: '',
          deptName: '',
          description: '',
          director: '',
          phone: ''
        };
        this.dialogVisible = true;
      },
      
      // 编辑科室
      handleEdit(row) {
        this.dialogType = 'edit';
        this.dialogTitle = '编辑科室';
        this.deptForm = { ...row };
        this.dialogVisible = true;
      },
      
      // 删除科室
      handleDelete(row) {
        if (row.doctorCount > 0) {
          this.$message.warning('该科室下有医生，不能删除！');
          return;
        }
        
        this.$confirm('确定要删除该科室吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          const index = this.departments.findIndex(item => item.deptId === row.deptId);
          if (index !== -1) {
            this.departments.splice(index, 1);
            this.$message.success('删除成功');
            this.totalCount--;
          }
        }).catch(() => {
          // 取消删除操作
        });
      },
      
      // 提交表单
      submitForm() {
        this.$refs.deptForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            setTimeout(() => {
              if (this.dialogType === 'add') {
                // 模拟添加操作
                const newDept = {
                  ...this.deptForm,
                  doctorCount: 0,
                  createTime: new Date().toLocaleString()
                };
                this.departments.push(newDept);
                this.totalCount++;
                this.$message.success('添加成功');
              } else {
                // 模拟编辑操作
                const index = this.departments.findIndex(item => item.deptId === this.deptForm.deptId);
                if (index !== -1) {
                  // 保留不在表单中的字段
                  const doctorCount = this.departments[index].doctorCount;
                  const createTime = this.departments[index].createTime;
                  this.departments[index] = {
                    ...this.deptForm,
                    doctorCount,
                    createTime
                  };
                  this.$message.success('编辑成功');
                }
              }
              this.loading = false;
              this.dialogVisible = false;
            }, 500);
          } else {
            return false;
          }
        });
      },
      
      // 分页相关方法
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      
      // 导入相关方法
      handleFileChange(file) {
        this.fileList = [file];
      },
      downloadTemplate() {
        // 模拟下载模板操作
        this.$message.success('模板下载成功');
      },
      submitImport() {
        if (this.fileList.length === 0) {
          this.$message.warning('请先选择要上传的文件');
          return;
        }
        
        this.$message.success('导入成功，共导入5条科室信息');
        this.importDialogVisible = false;
        this.fileList = [];
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .departments {
    padding: 20px;
    
    h2 {
      margin-bottom: 20px;
      font-weight: 500;
      color: #303133;
    }
    
    .operation-area {
      display: flex;
      margin-bottom: 15px;
    }
    
    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    
    .import-tip {
      margin-bottom: 15px;
      padding: 8px 12px;
      background-color: #fdf6ec;
      border-radius: 4px;
    }
    
    .upload-demo {
      display: flex;
      justify-content: center;
      margin: 20px 0;
    }
  }
  </style>